import API from '../dataAccess/api'

export default async (to, from, next) => {
  const response = await API.getUser()
  const user = response.data
  if (user.is_admin_or_superuser) {
    next()
  } else {
    next('/')
  }
}
